export const defaultUploaderState = {
  files: [],
  features: [],
  groupedFiles: {},
  activeGroupIndex: null,
  activeGroup: null,
  groupKeys: [],
};

export const addFiles = files => ({
  type: 'add-files',
  files,
});

export const setFiles = files => ({
  type: 'set-files',
  files,
});

export const setFeatures = features => ({
  type: 'set-features',
  features,
});

export const addFeatures = features => ({
  type: 'add-features',
  features,
});

export const addGroupedFiles = files => ({
  type: 'add-grouped-files',
  groupedFiles: files,
});

export const setGroupedFiles = files => ({
  type: 'set-grouped-files',
  groupedFiles: files,
});

export const removeGroupedFile = groupKey => ({
  type: 'remove-grouped-file',
  groupKey,
});

export const setActiveGroup = group => ({
  type: 'set-active-group',
  group,
});

export const setActiveGroupIndex = index => ({
  type: 'set-active-group-index',
  index,
});

export const uploaderReducer = (state = defaultUploaderState, action) => {
  switch (action.type) {
    case 'add-files':
      return {
        ...state,
        files: state.files.concat(action.files),
      };
    case 'set-files':
      return {
        ...state,
        files: action.files,
      };
    case 'set-features':
      return {
        ...state,
        features: action.features,
      };
    case 'add-features':
      return {
        ...state,
        features: state.features.concat(action.features),
      };
    case 'add-grouped-files': {
      const groups = {...state.groupedFiles, ...action.groupedFiles};

      return {
        ...state,
        groupedFiles: groups,
        groupKeys: Object.keys(groups),
      };
    }
    case 'set-grouped-files':
      return {
        ...state,
        groupedFiles: action.groupedFiles,
        groupKeys: Object.keys(action.groupedFiles),
      };
    case 'remove-grouped-file': {
      const newGroup = {...state.groupedFiles};
      delete newGroup[action.groupKey];
      return {
        ...state,
        groupKeys: state.groupKeys.filter(key => key !== action.groupKey),
        files: state.files.filter(file => {
          const group = state.groupedFiles[action.groupKey];
          return !group.files.includes(file) && group.parent !== file.name;
        }),
        groupedFiles: newGroup,
      };
    }
    case 'set-active-group':
      return {
        ...state,
        activeGroup: action.group,
      };

    case 'set-active-group-index':
      return {
        ...state,
        activeGroupIndex: action.index,
      };
    default:
      return state;
  }
};
